module.exports = __webpack_public_path__ + "static/media/Import.a728527b.svg";